import React, { Component } from 'react';

class CatalogBreadcrumb extends Component {
    
  render() {
    var p      = this.props.location.pathname;
    var path   = this.props.location.pathname.toLowerCase();
    var search = 'Search';
    var result = 'Result';
    if (p.includes('/search/category/')) {
      search = p.split('/')[3];
    }
    else if (p.includes('/result/category/')) {
      search = p.split('/')[3];
    }
    
    if (p.includes('/search/category/') && p.includes('/sub/')) {
      result = p.split('/')[5];
    }
    else if (p.includes('/result/category/') && p.includes('/sub/')) {
      result = p.split('/')[5];
    }
    
    return (
      <div className="c-breadcrumbs__wrapper" >
        <ul className="c-breadcrumbs">
          <li className="c-breadcrumbs__item">
            <a href="/#/catalog" className="anchor c-breadcrumbs__anchor" >
              Home
            </a>
          </li>
          { ((path.startsWith('/search/') && !path.startsWith('/search/category/')) || (path.startsWith('/result/') && !path.startsWith('/result/category/'))) && this.props.search && this.props.search.search ?
            <li className="c-breadcrumbs__item">
              <a href={"/#"+p} className="anchor c-breadcrumbs__anchor" >
                {this.props.search.search}
              </a>
            </li>
            :
            null
          }
          { (path.startsWith('/search/category/') || path.startsWith('/result/category/')) && !path.includes('/sub/') ?
            <li className="c-breadcrumbs__item">
              <a href={"/#"+p} className="anchor c-breadcrumbs__anchor" >
                {search}
              </a>
            </li>
            :
            null
          }
          { (path.startsWith('/search/category/') || path.startsWith('/result/category/')) && path.includes('/sub/') ?
            <li className="c-breadcrumbs__item">
              <a href={"/#" + p.split('/sub/')[0]} className="anchor c-breadcrumbs__anchor" >
                {search}
              </a>
            </li>
            :
            null
          }
          { !path.startsWith('/catalog') && (path.startsWith('/search') || path.startsWith('/result')) && path.includes('/sub/') ?
            <li className="c-breadcrumbs__item">
              <a href={"/#"+p} className="anchor c-breadcrumbs__anchor" >
                {result}
              </a>
            </li>
            :
            null
          }
        </ul>
      </div>
    );
  }
}

export default CatalogBreadcrumb;